import { Chip } from '@mui/material';
import {
  Schedule,
  PlayArrow,
  CheckCircle,
  Error,
  Pause,
  HourglassTop
} from '@mui/icons-material';
import { JobStatus } from '../../types/queue.types';

interface QueueJobStatusChipProps {
  status: JobStatus;
  size?: 'small' | 'medium';
}

const statusConfig = {
  [JobStatus.WAITING]: {
    label: 'In Attesa',
    color: '#757575' as const, // Grey
    icon: Schedule
  },
  [JobStatus.ACTIVE]: {
    label: 'In Elaborazione',
    color: '#1976d2' as const, // Blue
    icon: PlayArrow
  },
  [JobStatus.COMPLETED]: {
    label: 'Completato',
    color: '#0D8A7F' as const, // Green
    icon: CheckCircle
  },
  [JobStatus.FAILED]: {
    label: 'Fallito',
    color: '#d32f2f' as const, // Red
    icon: Error
  },
  [JobStatus.DELAYED]: {
    label: 'Ritardato',
    color: '#E67700' as const, // Orange
    icon: HourglassTop
  },
  [JobStatus.PAUSED]: {
    label: 'In Pausa',
    color: '#9e9e9e' as const, // Darker grey
    icon: Pause
  }
};

const QueueJobStatusChip: React.FC<QueueJobStatusChipProps> = ({ status, size = 'small' }) => {
  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <Chip
      icon={<Icon sx={{ color: config.color + ' !important' }} />}
      label={config.label}
      size={size}
      sx={{
        backgroundColor: config.color + '20',
        color: config.color,
        fontWeight: 600,
        borderColor: config.color,
        '& .MuiChip-icon': {
          color: config.color
        }
      }}
    />
  );
};

export default QueueJobStatusChip;